import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import withWidth from "@material-ui/core/withWidth/withWidth";
import Grid from "@material-ui/core/Grid/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import PropTypes from "prop-types";
import Icon from "@material-ui/core/Icon/Icon";
import Divider from "@material-ui/core/Divider/Divider";

import Typography from "@material-ui/core/Typography/Typography";
const styles = (theme) => ({
  MuiFormControlRoot: {
    display: "flex !important",
    [theme.breakpoints.up("sm")]: {
      marginTop: 15,
      marginBottom: 20,
    },
    "& label": {
      fontSize: 15,
    },
  },
  checkboxLabel: {
    fontSize: 15,
    paddingLeft: 15,
    paddingBottom: 12,
    [theme.breakpoints.down("xs")]: {
      paddingLeft: 12,
    },
  },
  formHelperText: {
    marginLeft: 45,
    marginBottom: 0,
  },
  infoText: {
    marginTop: 20,
    whiteSpace: "pre-wrap",
    display: "flex",
    flexDirection: "row",
  },
  infoIcon: {
    margin: "0 10px auto 0",
  },
});

class AcceptDesign extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    noteLabel: PropTypes.string,
    notice: PropTypes.string,
    handleChange: PropTypes.func,
    width: PropTypes.string,
    handleChangeCheckboxApproval: PropTypes.func,
    approval: PropTypes.object,
    displayAcceptDesign: PropTypes.bool,
    termsAndConditionsLink: PropTypes.string,
  };
  render() {
    const {
      classes,
      noteLabel,
      notice,
      handleChange,
      handleChangeCheckboxApproval,
      approval,
      displayAcceptDesign,
      termsAndConditionsLink,
    } = this.props;

    const termsLink = `<a href="${termsAndConditionsLink}"
                              target="_blank">${t(
                                "acceptDesignScreen.termsAndConditionsLinkLabel"
                              )}</a>`;
    const termsAndConditions = termsAndConditionsLink
      ? " " +
        t("acceptDesignScreen.termsAndConditions", {
          termsAndConditionsLink: termsLink,
        })
      : "";

    return (
      <>
        <Divider style={{ marginBottom: 10 }} />
        <Typography className={classes.infoText} variant="body1">
          <Icon className={classes.infoIcon}>info</Icon>
          <span>{t("acceptDesignScreen.info")}</span>
        </Typography>
        <Grid container>
          <Grid item xs={12}>
            <TextField
              label={noteLabel}
              multiline
              rows="3"
              rowsMax="3"
              value={notice}
              onChange={handleChange}
              margin="normal"
              variant="outlined"
              classes={{
                root: classes.MuiFormControlRoot,
              }}
            />
          </Grid>
          {displayAcceptDesign && (
            <Grid item xs={12}>
              {approval.error && (
                <FormHelperText error={true} className={classes.formHelperText}>
                  {t("acceptDesignScreen.selectionError")}
                </FormHelperText>
              )}
              <FormControlLabel
                className={classes.checkboxLabel}
                control={
                  <Checkbox
                    name="approval"
                    checked={approval.value}
                    onChange={handleChangeCheckboxApproval}
                    color="primary"
                  />
                }
                label={
                  <span
                    dangerouslySetInnerHTML={{
                      __html:
                        t("acceptDesignScreen.checkedSelectionActive") +
                        termsAndConditions,
                    }}
                  />
                }
              />
            </Grid>
          )}
        </Grid>
      </>
    );
  }
}

export default withWidth()(
  withStyles(styles, { name: "AcceptDesign" })(AcceptDesign)
);
